import { IMActivity } from '../../types'
import { parseStandardsGroup } from '../standards'
import { getQuestions } from './questions/questions'
import { noteNodes } from './noteNodes/noteNodes'
import { IM360Parser } from '../IM360Parser'

export function parseActivity(activity: IMActivity) {
  const { preNodes, postNodes } = noteNodes(activity)
  return IM360Parser.getInstance().createActivity(
    {
      title: activityTitle(activity),
      assignment: 'participation',
      assessment_grading: 'formative',
    },
    [
      ...parseStandardsGroup(activity.standards, activity.ancillary_content),
      ...preNodes,
      ...getQuestions(activity),
      ...postNodes,
    ],
  )
}

function activityTitle({
  ordinal_title,
  title,
  title_for_display_notation,
  title_for_display,
}: IMActivity) {
  if (title_for_display === 'Activity') {
    return `${title_for_display_notation}:  ${title}`
  }
  if (title_for_display_notation) {
    return `${title_for_display_notation}: ${title_for_display}:  ${title}`
  }
  return `${ordinal_title}: ${title}`
}
